export const last = <T>(array: T[] | undefined): T | undefined =>
  array?.[array.length - 1];
